import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-24 border-t border-border-subtle">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-bg-panel border border-accent/20 rounded-2xl p-6 md:p-8">
          <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_0.8fr] gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-bg-surface border border-accent/30 text-accent text-xs font-mono uppercase tracking-widest mb-5">
                <span className="w-1.5 h-1.5 rounded-full bg-success animate-pulse" />
                Today&apos;s challenge
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
                Train your incident instincts in 60 seconds a day
              </h2>
              <p className="text-text-secondary text-base leading-relaxed max-w-2xl mb-6">
                ExplainError Daily is built for engineers who want sharper incident judgement,
                faster triage thinking, and more confidence when production signals get noisy.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/challenge"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent hover:bg-accent-hover text-bg-base font-semibold rounded-md"
                >
                  Play today&apos;s challenge
                </Link>
                <Link
                  to="/leaderboard"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-border-muted hover:border-border-active text-text-secondary hover:text-text-primary font-medium rounded-md"
                >
                  See the leaderboard
                </Link>
              </div>
            </div>

            <div className="bg-bg-elevated border border-border-subtle rounded-xl p-5">
              <div className="text-xs font-mono text-text-muted uppercase tracking-wider mb-3">
                What you practise
              </div>
              <div className="space-y-3 text-sm text-text-secondary">
                <div className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-accent mt-1.5" />
                  <span>Recognising realistic failure patterns</span>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-accent mt-1.5" />
                  <span>Assessing severity without overreacting</span>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-accent mt-1.5" />
                  <span>Choosing a stronger first operational move</span>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-accent mt-1.5" />
                  <span>Building a daily production-awareness habit</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}